import { useContext, useState } from "react";
import "./restaurant-kitchen.styles.scss";
import { OrdersContext } from "../../../contexts/orders.context";
import RestaurantKitchenOrder from "./restaurant-kitchen-order/restaurant-kitchen-order.component";
const RestaurantKitchen = () => {
  const {
    preparingOrders,
    doneOrders,
    placedOrders,
    changeOrderStatus,
    orderItems,
    setOrderItems,
  } = useContext(OrdersContext);

  const [ordersClass, setOrdersClass] = useState("rk-mobile-button active");
  const [toPrepareClass, setToPrepareClass] = useState("rk-mobile-button");
  const [currentPane, setCurrentPane] = useState("orders");
  const changePane = (pane) => {
    setCurrentPane(pane);
    if (pane === "orders") {
      setOrdersClass("rk-mobile-button active");
      setToPrepareClass("rk-mobile-button");
    } else if (pane === "toprepare") {
      setOrdersClass("rk-mobile-button");
      setToPrepareClass("rk-mobile-button active");
    }
  };

  const handlePushOne = (index) => {
    var newObject = {};
    var newCount;
    Object.keys(orderItems).map((i) => {
      if (index === i) {
        newCount = orderItems[i] - 1;
      } else {
        newCount = orderItems[i];
      }
      if (newCount > 0) {
        newObject = { ...newObject, [i]: newCount };
      }
      return 0;
    });
    setOrderItems(newObject);
  };
  return (
    <div className="restaurant-kitchen-container">
      {window.innerWidth > 1024 ? (
        <div className="restaurant-kitchen-desktop">
          <div className="restaurant-kitchen-orders">
            {Object.keys(preparingOrders).map((index) => {
              const tempObject = preparingOrders[index];
              return (
                <RestaurantKitchenOrder
                  key={index}
                  orderObject={tempObject}
                  index={index}
                  changeOrderStatus={changeOrderStatus}
                />
              );
            })}
            {Object.keys(placedOrders).map((index) => {
              const tempObject = placedOrders[index];
              return (
                <RestaurantKitchenOrder
                  key={index}
                  orderObject={tempObject}
                  index={index}
                  changeOrderStatus={changeOrderStatus}
                />
              );
            })}
            {Object.keys(doneOrders).map((index) => {
              const tempObject = doneOrders[index];
              return (
                <RestaurantKitchenOrder
                  key={index}
                  orderObject={tempObject}
                  index={index}
                  changeOrderStatus={changeOrderStatus}
                />
              );
            })}
          </div>
          <div className="restaurant-kitchen-toprepare">
            <div className="restaurant-kitchen-toprepare-box">
              <div className="rk-tp-header">
                <span className="rk-tp-header-item">Details</span>
                <span className="rk-tp-header-item">Push to floor</span>
              </div>
              {Object.keys(orderItems).map((index) => {
                return (
                  <div key={index} className="rk-tp-item">
                    <div className="rk-tp-item-details">
                      <span className="rk-tp-item-name">{index}</span>
                      <span className="rk-tp-item-count">
                        x {orderItems[index]}
                      </span>
                    </div>
                    <div className="rk-tp-item-push-box">
                      <span
                        className="rk-tp-item-push"
                        onClick={() => handlePushOne(index)}
                      >
                        Push one
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        <div className="restaurant-kitchen-mobile">
          <div className="rk-mobile-buttons">
            <span className={ordersClass} onClick={() => changePane("orders")}>
              Orders
            </span>
            <span
              className={toPrepareClass}
              onClick={() => changePane("toprepare")}
            >
              To Prepare
            </span>
          </div>
          {currentPane === "orders" ? (
            <div className="restaurant-kitchen-orders">
              {Object.keys(preparingOrders).map((index) => {
                const tempObject = preparingOrders[index];
                return (
                  <RestaurantKitchenOrder
                    key={index}
                    orderObject={tempObject}
                    index={index}
                    changeOrderStatus={changeOrderStatus}
                  />
                );
              })}
              {Object.keys(placedOrders).map((index) => {
                const tempObject = placedOrders[index];
                return (
                  <RestaurantKitchenOrder
                    key={index}
                    orderObject={tempObject}
                    index={index}
                    changeOrderStatus={changeOrderStatus}
                  />
                );
              })}
              {Object.keys(doneOrders).map((index) => {
                const tempObject = doneOrders[index];
                return (
                  <RestaurantKitchenOrder
                    key={index}
                    orderObject={tempObject}
                    index={index}
                    changeOrderStatus={changeOrderStatus}
                  />
                );
              })}
            </div>
          ) : (
            <div className="restaurant-kitchen-toprepare">
              <div className="restaurant-kitchen-toprepare-box">
                <div className="rk-tp-header">
                  <span className="rk-tp-header-item">Details</span>
                  <span className="rk-tp-header-item">Push to floor</span>
                </div>
                {Object.keys(orderItems).map((index) => {
                  return (
                    <div key={index} className="rk-tp-item">
                      <div className="rk-tp-item-details">
                        <span className="rk-tp-item-name">{index}</span>
                        <span className="rk-tp-item-count">
                          x {orderItems[index]}
                        </span>
                      </div>
                      <div className="rk-tp-item-push-box">
                        <span
                          className="rk-tp-item-push"
                          onClick={() => handlePushOne(index)}
                        >
                          Push one
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default RestaurantKitchen;
